import { BilletLogModel } from "./BilletLogModel"

interface ExternalInfoItem {
    [key:string]: any;
}

interface ExternalInfoPayment {
    [key:string]: any;
}

interface ExternalInfoMetadata {
    [key:string]: any;
}

interface ExternalInfo {
    items: ExternalInfoItem[];
    payment: ExternalInfoPayment;
    metadata: ExternalInfoMetadata;
}

export class BilletModel {
    id?: string
    urlPdf: string|null = null
    urlView: string|null = null 
    createdAt: Date|string = new Date()
    canceledAt?: string|null = null
    dueDate: string = ''
    idExternal: string|null = null
    externalInfo: ExternalInfo|null = null
    logs: BilletLogModel[] = [];

    constructor(i?:Partial<BilletModel>) {
        Object.assign(this, i)

        this._parseLogs();
    }

    hasBeenCanceled():boolean {
        return !!this.canceledAt
    }

    private _parseLogs():void {
        this.logs = this.logs.map((log) => {
            return new BilletLogModel(log)
        })
    }
}
